import { render, staticRenderFns } from "./GoodsBargain.vue?vue&type=template&id=423e9328&scoped=true"
import script from "./GoodsBargain.vue?vue&type=script&lang=js"
export * from "./GoodsBargain.vue?vue&type=script&lang=js"
import style0 from "./GoodsBargain.vue?vue&type=style&index=0&id=423e9328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423e9328",
  null
  
)

export default component.exports